// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2iXoT","colMin":"styles_colMin__1sKq6","colCheckbox":"styles_colCheckbox__3ntEl"};